/* stack.tsx generated by @compiled/babel-plugin v0.35.0 */
import "./stack.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { Children } from 'react';
var listStyles = null;
var listItemStyles = null;
var Stack = function Stack(_ref) {
  var children = _ref.children,
    testId = _ref.testId,
    label = _ref['aria-label'];
  return /*#__PURE__*/React.createElement("ul", {
    "data-testid": testId,
    "aria-label": label,
    className: ax(["_18s8ze3t _1yt4ze3t _1e0c1txw _19121cl4 _vwz4kb7n _2mzuagmp _12l2u2gc"])
  }, Children.map(children, function (child) {
    return child && /*#__PURE__*/React.createElement("li", {
      className: ax(["_18s8ze3t _12l2x0bf"])
    }, child);
  }));
};

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export default Stack;